export default "__VITE_ASSET__D8Y0m0dn__"